import React, { Component } from "react";
import Menu from '../../components/Menu/Menu';
import Header from '../../components/Header/Header';
import Cards from '../../components/Cards/Cards';
import Footer from '../../components/Footer/Footer';
import './Home.css';

class Home extends Component{
    render(){
        return(
            <div>
                <Menu/>
                <Header/>
                <Cards/>
                <Footer/>
            </div>
        );
    }
}
export default Home;